import(/* webpackMode: "eager" */ "/home/runner/work/medprev-web-app/medprev-web-app/packages/frontend/app/error.tsx");
